import { Box, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

export const PINEHOOD_URL = "https://pinehood.tech";
export const PRIVACY_URL = "https://cloud.pinehood.tech/privacy/";
export const TERMS_URL = "https://cloud.pinehood.tech/terms/";

export function LegalFooter() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        mt: "auto",
        borderTop: 1,
        borderColor: "divider",
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Link
        href={PINEHOOD_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="caption"
        underline="hover"
        sx={{
          color: "text.secondary",
        }}
      >
        {t("footer.copyright", { year })}
      </Link>
      <Link
        href={TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="caption"
        sx={{
          color: "text.secondary",
        }}
      >
        {t("footer.terms")}
      </Link>
      <Link
        href={PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        variant="caption"
        sx={{
          color: "text.secondary",
        }}
      >
        {t("footer.privacy")}
      </Link>
    </Box>
  );
}
